// @ vendors
const apiURLBuilder = require('../core/apiURLBuilder');
const Api = require('../services/api');
// @ constants
const actionTypes = require('constants/actionTypes');
const { ISIN, DGS, INVD } = require('constants/products');

const getWealthProductService = (wealth, dispatch, callback) => {
    let url, param;

    switch (wealth.type) {
        case ISIN:
            url = 'getIsin';
            param = { isin: wealth.code };
            break;
        case DGS:
            url = 'getDGS';
            param = { dgs: wealth.code };
            break;
        case INVD:
            url = 'getINVD';
            param = { portfolioId: wealth.code };
            break;
        default:
            break;
    }

    Api.get(apiURLBuilder.getURL(url, param))
        .then(response => {
            if (!(response.body.total || response.body.portfolioId)) {
                dispatch({
                    type: actionTypes.ERROR_WEALTH_PRODUCT,
                });
                dispatch({
                    type: actionTypes.HIDE_SPINNER,
                });

                callback(false, response);
            } else {
                let name = null;
                let sec = null;
                switch (wealth.type) {
                    case ISIN:
                    case DGS:
                        name = response.body.rows[0].Name;
                        sec = response.body.rows[0].SecId;
                        break;
                    case INVD:
                        name = response.body.portfolioDesc;
                        break;
                    default:
                        break;
                }
                const data = {
                    wealthType: wealth.type,
                    wealthCode: wealth.code,
                    wealthName: name,
                    wealthSecId: sec,
                };
                dispatch({
                    type: actionTypes.SET_WEALTH_PRODUCT,
                    data: data,
                });

                dispatch({
                    type: actionTypes.HIDE_SPINNER,
                });
                callback(true);
            }
        })
        .catch(error => {
            dispatch({
                type: actionTypes.ERROR_WEALTH_PRODUCT,
                error,
            });

            dispatch({
                type: actionTypes.HIDE_SPINNER,
            });

            callback(false, error);
        });
};

const getWealthProduct = (wealth, callback) => {
    return dispatch => {
        getWealthProductService(wealth, dispatch, callback);
    };
};

const clearWealthProduct = () => {
    return dispatch => {
        dispatch({
            type: actionTypes.CLEAR_WEALTH_PRODUCT,
        });
    };
};

const setWealthProduct = data => {
    return dispatch => {
        dispatch({
            type: actionTypes.SET_WEALTH_PRODUCT,
            data: data,
        });
    };
};

export default {
    getWealthProduct,
    clearWealthProduct,
    setWealthProduct,
};
